import React from 'react';
import { Sparkles } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
export function AboutSection() {
  return <section id="about" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#050505'
  }} data-id="element-56">
      <div className="max-w-3xl mx-auto text-center reveal" data-id="element-57">
        <div className="inline-flex items-center space-x-2 bg-[#c9a84c]/10 border border-[#c9a84c]/30 rounded-full px-4 py-1.5 mb-6" data-id="element-58">
          <Sparkles className="w-4 h-4 text-[#c9a84c]" data-id="element-59" />
          <span className="text-[#c9a84c] text-sm font-medium" data-id="element-60">
            About ai.web
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-61">
          About <span className="gold-gradient-text" data-id="element-62">ai.web</span>
        </h2>
        <p className="text-white/70 leading-relaxed text-lg mb-4" data-id="element-63">
          We're a small studio building affordable, high-converting websites for
          Irish small businesses.
        </p>
        <p className="text-white/60 leading-relaxed" data-id="element-64">
          One-time payment, no tech skills needed, fast launch. From
          electricians in Dublin 8 to restaurants in Temple Bar — ai.web helps
          Irish businesses get found on Google and turn visitors into customers.
        </p>
      </div>
      <SectionDivider data-id="element-65" />
    </section>;
}